<template>
  <h1>User account</h1>
  <template v-if="userDetails!==undefined">
    <table class="w3-table">
        <tr>
          <!-- <th></th> -->
          <th>Name</th>
          <th>Email</th>
          <th>Home/Institute</th>
          <th>Orders</th>
        </tr>
        <tr>
          <td>{{userDetails['details']['name'] }}</td>
          <td>{{userDetails['email']}}</td>
          <td>{{userDetails['details']['home_institute']}}</td>
          <td><a href='/distribution/myorders'>My Orders</a></td>
        </tr>
    </table>
  </template>

</template>

<script>
// import VueNumberInput from '@chenfengyuan/vue-number-input';

export default {
  name: 'User',
  // components: {
  //   VueNumberInput,
  // },
  data() {
    return {
        value: 1,
      };
  },
  computed: {
    userDetails() {
      return JSON.parse(JSON.stringify(this.$store.getters.getUserDetails));
    }
  }
}
</script>